// Поля которые есть у всех серий
export const eppOptions = {
  selectionType: "general",
  id: "general",
  position: "vertical",
  selectionTitle: "Общие параметры",
  selectionOptions: [
    {
      name: "Q",
      id: "Q",
      fieldType: "number",
      titleRus: "Расход",
      type: "inputs-group",
      required: "required",
      message:
        "Выберите корректный параметр для Расход от {{ min }} до {{ max }}",
      restrictions: {
        min: "0",
        max: "999999999.99",
      },
      measureId: "units",
      measureOptions: {
        "м³/ч": "m",
        "л/с": "l",
      },
    },
    {
      name: "H",
      id: "H",
      fieldType: "number",
      titleRus: "Напор, м",
      type: "input",
      required: "required",
      message:
        "Выберите корректный параметр для Напор от {{ min }} м до {{ max }} м",
      restrictions: {
        min: "0",
        max: "999.99",
      },
    },
    {
      name: "H0",
      id: "H0",
      fieldType: "number",
      titleRus: "Статический напор, м",
      type: "input",
      required: "required",
      message:
        "Выберите корректный параметр для Статический напор от {{ min }} м до {{ max }} м",
      restrictions: {
        min: "0",
        max: "999.99",
      },
    },
  ],
};

// Дополнительные поля, которые зависят от серии
export const eppAdditionalOptions = [
  {
    name: "pcnt",
    id: "pcnt",
    fieldType: "number",
    type: "select",
    titleRus: "Число насосов",
    options: {
      1: 1,
      2: 2,
      3: 3,
      4: 4,
      5: 5,
      6: 6,
      7: 7,
      8: 8,
      9: 9,
      10: 10,
    },
  },
  {
    name: "BoxType",
    id: "BoxType",
    fieldType: "number",
    type: "radio",
    titleRus: "Частотное регулирование",
    options: {
      Да: 0,
      Нет: 2,
    },
  },
  {
    name: "Liq",
    id: "Liq",
    fieldType: "number",
    type: "select",
    titleRus: "Тип жидкости",
    options: {
      Вода: 0,
      "Этиленгликоль": 3,
    },
  },
  {
    name: "Conc",
    id: "Conc",
    fieldType: "number",
    type: "input",
    titleRus: "Концентрация, %",
    restrictions: {
      min: "0",
      max: "59",
    },
    dependsOn: {
      field: "Liq",
      value: 3,
    },
  },
  {
    name: "Temp",
    id: "Temp",
    fieldType: "number",
    type: "input",
    titleRus: "Температура, °C",
    restrictions: {
      min: "-25",
      max: "60",
    },
    dependsOn: {
      field: "Liq",
      value: 3,
    },
  },
];
